import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';
import { chevronLeftGutter, iconLeftSpacer } from './win32FolderIconProps.scss';

const renderIconSpacer = (_className: string): JSX.Element => (
    <span className={iconLeftSpacer} aria-hidden={true} />
);

export interface Win32FolderNodeIconProps {
    hideIcon: boolean;
    onRenderCustomIcon: ((className: string) => JSX.Element) | undefined;
    chevronIconButtonClassName: string | undefined;
}

/**
 * Returns FolderNode icon props for the Win32 overlay icon-hiding pattern:
 * expandable folders use a chevron gutter; leaf folders use a fixed-width spacer.
 */
export function getWin32FolderNodeIconProps(isFolderExpandable: boolean): Win32FolderNodeIconProps {
    const shouldHideIcons = isWin32StylingEnabled();
    return {
        hideIcon: shouldHideIcons && isFolderExpandable,
        onRenderCustomIcon: shouldHideIcons && !isFolderExpandable ? renderIconSpacer : undefined,
        chevronIconButtonClassName: shouldHideIcons ? chevronLeftGutter : undefined,
    };
}
